/* eslint-disable no-param-reassign */
import { quoteAPI } from "../api";

const setLoading = (loading) => async (dispatch) =>
  dispatch({ type: "SET_ESTIMATE_LOADING", loading });

const setEstimate = (details) => async (dispatch) =>
  dispatch({ type: "SET_ESTIMATE", details });

const setSuccess = (success) => async (dispatch) =>
  dispatch({ type: "SET_ESTIMATE_SUCCESS", success });

const setDone = (done) => async (dispatch) =>
  dispatch({ type: "SET_DONE", done });

const setPreviousValues = (values) => async (dispatch) =>
  dispatch({ type: "SET_PREVIOUS_VALUES", previousValues: values });

export const setError = (error) => async (dispatch) =>
  dispatch({ type: "SET_ESTIMATE_ERROR", error });

export const setDateRange = (date_range) => async (dispatch) =>
  dispatch({ type: "SET_DATE_RANGE", date_range });

export const getEstimate = (values) => async (dispatch) => {
  dispatch(setLoading(true));
  dispatch(setPreviousValues(values));

  // remove estimateActions from post data for international (causes server error)..
  const postData = { ...values };
  if (postData.international && postData.estimateActions) {
    delete postData.estimateActions;
  }

  return quoteAPI
    .post(`get_estimate`, postData)
    .then(({ data }) => {
      const { estimate, id, to, from, packing_cost } = data;
      if (values.international) {
        dispatch(setDone(true));
      } else {
        dispatch(setEstimate({ estimate, id, to, from, packing_cost }));
      }
      dispatch(setError(null));
      dispatch(setLoading(false));
      return true;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error: ", e);
      dispatch(setError(e));
      dispatch(setLoading(false));
      return false;
    });
};

export const acceptEstimate = (values, quoteNumber) => async (dispatch) => {
  dispatch(setLoading(true));
  return quoteAPI
    .put(`accept_estimate/${quoteNumber}`, values)
    .then(() => {
      dispatch(setSuccess(true));
      dispatch(setError(null));
      dispatch(setDone(true));
      dispatch(setLoading(false));
      return true;
    })
    .catch((e) => {
      // eslint-disable-next-line no-console
      console.error("Error: ", e);
      dispatch(setError(e));
      dispatch(setLoading(false));
      return false;
    });
};
